export enum TipoAIDFEnum {

  Bloco = "Bloco",
  Formulario = "Formulario Contínuo",
  JogosSoltos = "Jogos Soltos",
  BlocoBP = "Bloco BP"
}
